import http from '@/utils/ajax'
import { POLCRCD_SAVE_LOADING, POLCRCD_SAVE_SUCCESS, POLCRCD_SAVE_FAIL, POLCRCD_LOAD_DATA, POLBANKDR_SAVE_LOADING, POLBANKDR_SAVE_SUCCESS, POLBANKDR_SAVE_FAIL, POLBANKDR_LOAD_DATA, POLCLSE_SAVE_LOADING, POLCLSE_SAVE_SUCCESS, POLCLSE_SAVE_FAIL, POLHDRSTATS_SAVE_LOADING, POLHDRSTATS_SAVE_SUCCESS, POLHDRSTATS_SAVE_FAIL } from '@/store/types'

export const header = {
  async savePolCrCd({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.policyHeaderSettings.menu.savePolCrCd

    if (apiUrl) {
      commit(POLCRCD_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(POLCRCD_SAVE_SUCCESS, commitObject)
          commit(POLCRCD_LOAD_DATA, commitObject.data)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLCRCD_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLCRCD_SAVE_FAIL, generateManualSaveError(['Fail to create Payment']))
        }
        return false
      }
    } else {
      commit(POLCRCD_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  },
  async savePolBankDr({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.policyHeaderSettings.menu.savePolBankDr

    if (apiUrl) {
      commit(POLBANKDR_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(POLBANKDR_SAVE_SUCCESS, commitObject)
          commit(POLBANKDR_LOAD_DATA, commitObject.data)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLBANKDR_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLBANKDR_SAVE_FAIL, generateManualSaveError(['Fail to create Payment']))
        }
        return false
      }
    } else {
      commit(POLBANKDR_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  },
  async savePolClse ({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.policyHeaderSettings.menu.savePolClause
    if (apiUrl) {
      commit(POLCLSE_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(POLCLSE_SAVE_SUCCESS, commitObject)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLCLSE_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLCLSE_SAVE_FAIL, generateManualSaveError(['Fail to create Policy Clause']))
        }
        return false
      }
    } else {
      commit(POLCLSE_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  },
  async savePolHdrStats ({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.policyHeaderSettings.menu.savePolHdrStats
    if (apiUrl) {
      commit(POLHDRSTATS_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(POLHDRSTATS_SAVE_SUCCESS, commitObject)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLHDRSTATS_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLHDRSTATS_SAVE_FAIL, generateManualSaveError(['Fail to create Policy Statistics']))
        }
        return false
      }
    } else {
      commit(POLHDRSTATS_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  }
}

/**
 * To put manual messages into saveError
 * @param {Array of String} msgs
 */
const generateManualSaveError = (msgs) => {
  if (msgs && msgs.length > 0) {
    return {
      fieldMessages: [],
      messages: msgs
    }
  } else {
    return {
      fieldMessages: [],
      messages: []
    }
  }
}
/**
 * Format server return object to dialog readable format
 * @param {Server return object data} data
 */
const formatServerSaveError = (data) => {
  let fieldMessages = []
  let messages = []

  if (data) {
    if (data.messages && data.messages.length > 0) {
      for (const err of data.messages) {
        messages.push(err.message)
      }
    }
    if (data.fieldMessages && data.fieldMessages.length > 0) {
      for (const err of data.fieldMessages) {
        fieldMessages.push(err.field + ': ' + err.message.message)
      }
    }
  }
  return {
    fieldMessages: fieldMessages,
    messages: messages
  }
}
